import React from "react";
import Button from "../common/Button/Button";
import PermissionsGate from "../../utils/permissionGate";
import { ActionButtonRow } from "./careerLibrary.styles";

/**
 * The design's row action pair: a primary open button and a danger button,
 * using the shared Button component's campus-action-button treatment.
 * @param {object} props open/danger handlers, icons, titles and permission scopes
 */
function RowActions({
  onOpen,
  openTitle = "Open",
  openScopes = [],
  onDanger,
  dangerTitle = "Delete",
  dangerIcon = "fal fa-trash-alt",
  dangerScopes = [],
}) {
  return (
    <ActionButtonRow>
      <PermissionsGate scopes={openScopes} errorProps={{ disabled: true }}>
        <Button
          className="btn btn-primary campus-action-button campus-action-button--edit"
          variant="primary"
          iconOnly
          iconLeft={
              <i
                className="fal fa-folder-open"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0,
                  lineHeight: 1,
                }}
              />
            }
          onClick={onOpen}
          title={openTitle}
        />
      </PermissionsGate>
      <PermissionsGate scopes={dangerScopes} errorProps={{ disabled: true }}>
        <Button
          className="btn btn-danger campus-action-button campus-action-button--delete"
          variant="danger"
          iconOnly
          iconLeft={
              <i
                className={dangerIcon}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0,
                  lineHeight: 1,
                }}
              />
            }
          onClick={onDanger}
          title={dangerTitle}
        />
      </PermissionsGate>
    </ActionButtonRow>
  );
}

export default RowActions;
